import http from './_http_v2'

const pdf = (m) => { return http.post(`/common/pdf`, m); }
const pdf_Call = (a, b, c) => pdf({target: a, cmd : b, body: c});

export default { pdf, pdf_Call}
export { pdf, pdf_Call }
